import { Module } from "vuex";
import { RootState } from "@/store/RootState";
import { mutations } from "@/components/channelsPage/store/mutations";
import { getters } from "@/components/channelsPage/store/getters";
import { actions } from "@/components/channelsPage/store/actions";
import { ChannelsPageState } from "@/components/channelsPage/types";

export const state: ChannelsPageState = {
  cardControls: false,
  playedChannelId: undefined,
  playedChannelIndex: undefined,
  playedChannelCategory: undefined,
  playedChannelView: undefined,
  activeChannelOverlayInfo: undefined,
  activeInfoScreenEpgItem: undefined,
  showInfoScreen: false,
  showEpgScreen: false
};

export const channelsPage: Module<ChannelsPageState, RootState> = {
  namespaced: true,
  state,
  actions,
  getters,
  mutations
};
